<template>
  <div :class="[{'card card--leg-results': isMobile}]">
    <slot name="header" />
    <div class="leg-results__results">
      <ul class="leg-results__results--list">
        <li
          v-for="legislator in legislators"
          :key="legislator.id"
          class="leg-results__results--entry"
        >
          <legislator-image
            :photo="legislator.photo"
            :name="legislator.photo"
            :placeholder-photo-url="placeholderPhotoUrl"
          />

          <legislator-name
            :name="legislator.name"
            :affiliation="legislator.affiliation"
          />
        </li>
      </ul>
    </div>
    <slot name="footer" />
  </div>
</template>
<script>
// conversational
import LegislatorImage from "./LegislatorImage.vue";
import LegislatorName from "./LegislatorName.vue";

export default {
  name: "LegislatorsList",
  components: { LegislatorImage, LegislatorName },
  props: {
    isMobile: {
      type: Boolean,
      default: false
    },
    legislators: {
      required: true,
      type: Array
    },
    placeholderPhotoUrl: {
      type: String,
      default: null
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
